<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ack"> </p>
<p class="FMH"><span epub:type="pagebreak" id="pg_vii" title="vii"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">Acknowledgments</span></span></p>
<p class="FMTNIS">The following people have my undying gratitude, and deserve special mention here; without them, you would not be holding this book in your hands:</p>
<p class="UL">Irwin Rumler</p>
<p class="UL">Russell Galen</p>
<p class="UL">Charles Spicer</p>
<p class="UL">April Osborn</p>
<p class="UL">David Blixt</p>
<p class="FMSTX">I’d like to thank each of the following individuals for supporting me in finishing this novel:</p>
<p class="CL2F">George A. Kalogridis</p>
<p class="CL2">Jan Davis and Mitchell Kalogridis</p>
<p class="CL2">Keith Macksey</p>
<p class="CL2">Melissa Clepper-Faith</p>
<p class="CL2">Jerry Miller</p>
<p class="CL2">Kathy, Matt, Daemon, and Lily Prorok</p>
<p class="CL2">C. W. Gortner</p>
<p class="CL2">Jackie Sewell</p>
<p class="CL2">Tim Waggoner</p>
<p class="CL2">Dimitri LaBarge</p>
<p class="CL2">Teresa Bigbee</p>
<p class="CL2"><span epub:type="pagebreak" id="pg_viii" title="viii">Kent Burden</span></p>
<p class="CL2">Frank Carbone</p>
<p class="CL2">David Tocher</p>
<p class="CL2">Samina Patel Sharp</p>
<p class="CL2">Bob Dev</p>
<p class="CL2">J. Martin</p>
<p class="CL2">Kristina Butke</p>
<p class="CL2">Mike Cobley</p>
<p class="CL2">H. W. Shannon</p>
<p class="CL2">sidhekist</p>
<p class="CL2">kayaking.gram</p>
<p class="CL2">jcpete</p>
<p class="CL2">hardboiledbaby</p>
<p class="CL2">dolleygurl</p>
<p class="CL2">Trent Zelazny</p>
<p class="CL2">Dawn Rice</p>
<p class="CL2">Laura Lewis</p>
<p class="CL2">Matt Phillips</p>
<p class="CL2">M. J. Rose</p>
<p class="CL2">Vidura Barrios</p>
<p class="CL2">Warren Lapine</p>
<p class="CL2">Andy Michael</p>
<p class="CL2">Nat P.</p>
<p class="CL2">Sarah Waterhouse</p>
<p class="CL2">Karen Essex</p>
<p class="CL2">Leslie Carrol</p>
<p class="CL2">Jonah Kit</p>
<p class="CL2">Laura Watkins</p>
<p class="CL2">Bob Moats</p>
<p class="CL2">Winston</p>
<p class="CL2">Gio Pompele</p>
<p class="CL2">Vincent Docherty</p>
<p class="CL2">Richard Dansky</p>
<p class="CL2">edidep</p>
<p class="CL2">dlteana.graham9</p>
<p class="CL2">lesliegski</p>
<p class="CL2">usmantm</p>
<p class="CL2">cesc.rosello</p>
<p class="CL2">hfvrtualbooktours</p>
<p class="FMSTX">My special thanks, also, to those who contributed anonymously; you know who you are.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?678ad085